(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[396],{

/***/ 4217:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return __webpack_require__(7722);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ privacy_policy; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./constants/policies.tsx
var policies = __webpack_require__(337);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/privacy-policy-sections/content/content-component.tsx



var PrivacyPolicySectionContentComponent = function(param) {
    var policy = param.policy;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-y-3 md:gap-y-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "h5 text-primary",
                children: policy.header
            }),
            policy.subheader != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "h6 text-text-color-high-em",
                children: policy.subheader
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col gap-y-6 md:gap-y-12",
                children: policy.clauses.map(function(clause, i1) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-y-2 md:gap-y-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "h6 text-color-high-em",
                                children: clause.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-body-md text-text-color-mid-em",
                                children: clause.body.split("<br/>").map(function(bodyContent, i2) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: bodyContent.includes("\u2022") ? "pl-2" : "",
                                        children: [
                                            bodyContent.split("<break-all>").length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "flex",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "pr-2",
                                                        children: "\u2022"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: bodyContent.split("<break-all>").map(function(bodyBreak, i3) {
                                                            return i3 === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: bodyBreak,
                                                                passHref: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "break-all cursor-pointer text-text-color-low-em",
                                                                    children: bodyBreak
                                                                })
                                                            }, i3) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: bodyBreak.split("[highlight]").length > 1 ? bodyBreak.replace("\u2022", "").split("[highlight]").map(function(highlightText, i) {
                                                                    return i === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "label-md text-text-color-high-em",
                                                                        children: highlightText
                                                                    }, i) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: highlightText
                                                                    }, i);
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: bodyBreak
                                                                })
                                                            }, i3);
                                                        })
                                                    })
                                                ]
                                            }) : bodyContent.includes("\u2022") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "flex",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "pr-2",
                                                        children: "\u2022"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "flex flex-col",
                                                        children: bodyContent.replace("\u2022", "").split(">").map(function(bullet, i4) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: bullet.split("[highlight]").length > 1 ? bullet.split("[highlight]").map(function(highlightText, i) {
                                                                    return i === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "label-md text-text-color-high-em",
                                                                        children: highlightText
                                                                    }, i) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: highlightText
                                                                    }, i);
                                                                }) : bullet.split("[highlight-med]").length > 1 ? bullet.replace("\u2022", "").split("[highlight-med]").map(function(highlightText, i) {
                                                                    return i === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "label-md",
                                                                        children: highlightText
                                                                    }, i) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: highlightText
                                                                    }, i);
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: bullet
                                                                }, i4)
                                                            }, i4);
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: bodyContent.includes("info@simplewaste.com") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: bodyContent.replace("info@simplewaste.com", "")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-primary pl-1",
                                                            children: "info@simplewaste.com"
                                                        })
                                                    ]
                                                }) : bodyContent
                                            }, i2),
                                            !bodyContent.includes("\u2022") && /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                        ]
                                    }, i2);
                                })
                            })
                        ]
                    }, i1);
                })
            })
        ]
    });
};
/* harmony default export */ var content_component = (PrivacyPolicySectionContentComponent);

;// CONCATENATED MODULE: ./components/privacy-policy-sections/content/index.tsx



var PrivacyPolicySectionContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col gap-y-6 md:gap-y-12 md:max-w-[720px]",
        children: policies/* privacyPolicies.map */.C.map(function(policy, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(content_component, {
                policy: policy
            }, i);
        })
    });
};
/* harmony default export */ var content = (PrivacyPolicySectionContent);

// EXTERNAL MODULE: ./components/gradient/gradient-text.tsx
var gradient_text = __webpack_require__(3725);
;// CONCATENATED MODULE: ./components/privacy-policy-sections/header.tsx


var PrivacyPolicySectionHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center gap-y-3 text-center md:max-w-[960px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-base-dark label-md",
                children: "Last updated: January 24, 2022"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "mobile-h3 xs:h4 md:h3",
                    children: "Privacy Policy"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "pt-3 text-text-color-mid-em",
                children: [
                    "This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Yourinformation when You use the Service and tells You about Your privacy rights and how the law protects You.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "We use Your Personal data to provide and improve the Service. By using the Service,You agree to the collection and use of information in accordance with this Privacy Policy."
                ]
            })
        ]
    });
};
/* harmony default export */ var header = (PrivacyPolicySectionHeader);

;// CONCATENATED MODULE: ./pages/privacy-policy.tsx



var PrivacyPolicyPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "m-6 md:m-20 flex flex-col gap-y-5 md:gap-y-10 items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(content, {})
        ]
    });
};
/* harmony default export */ var privacy_policy = (PrivacyPolicyPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [643,774,888,179], function() { return __webpack_exec__(4217); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);